import React from 'react';
import { Flex } from 'theme-ui';
import { useCart } from '@chordcommerce/react-autonomy';
import { AnimatePresence, motion } from 'framer-motion';
import { useCartItems } from '~/utils/use-cart-items';

import LineItem from '../LineItem';
const LineItems = React.memo(() => {
  const { cart } = useCart();

  const cartItems = useCartItems(cart);

  return (
    <Flex
      as="ul"
      role="list"
      aria-live="assertive"
      sx={{
        listStyle: 'none',
        p: 0,
        gap: '2rem',
        flexDirection: 'column',
      }}
    >
      <AnimatePresence>
        {cartItems?.map((lineItem) => (
          <motion.li
            layout="position"
            key={lineItem.id}
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ opacity: 0, scaleY: 0.5 }}
            transition={{ ease: 'easeInOut', duration: 0.4 }}
            sx={{ width: '100%' }}
          >
            <LineItem lineItem={lineItem} confirmed={false} />
          </motion.li>
        ))}
      </AnimatePresence>
    </Flex>
  );
});

export default LineItems;
